/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpRespShippingReturns_shipment$ref = any;
type PdpRespSidebarBlurbs_shipment$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespContainer_shipment$ref: FragmentReference;
export type PdpRespContainer_shipment = {|
  +$fragmentRefs: PdpRespSidebarBlurbs_shipment$ref & PdpRespShippingReturns_shipment$ref,
  +$refType: PdpRespContainer_shipment$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespContainer_shipment",
  "type": "Shipment",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_shipment",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespShippingReturns_shipment",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '420fd2aa2770bf47e7c888011c42b0e9';
module.exports = node;
